import React from "react";

function useOutsideClick<T>(callback: () => void, dependencies: any[]) {
  const ref = React.useRef<T | null>(null);

  React.useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      //console.log(`useOutsideClick event fired`);
      callback();
    }

    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    }
  }, dependencies);

  return ref;
};

export default useOutsideClick;
